// @flow
import * as React from 'react'

type Props = {
  component: string,
  children: React.Node,
}

// NOTE (jake): used as a way to use React.createElement while maintaing support for styleName
// https://github.com/gajus/babel-plugin-react-css-modules/issues/181#issuecomment-386787993
export default function CreateElement({ component, children, ...restProps }: Props) {
  return React.createElement(component, restProps, children)
}
